/**
 * Сумата словом — законово изискване за фактурите.
 * Работи за суми до един милиард, което е достатъчно.
 */

const ONES = ['нула', 'един', 'два', 'три', 'четири', 'пет', 'шест', 'седем', 'осем', 'девет'];
const ONES_F = ['нула', 'една', 'две', 'три', 'четири', 'пет', 'шест', 'седем', 'осем', 'девет'];
const TEENS = ['десет', 'единадесет', 'дванадесет', 'тринадесет', 'четиринадесет',
  'петнадесет', 'шестнадесет', 'седемнадесет', 'осемнадесет', 'деветнадесет'];
const TENS = ['', '', 'двадесет', 'тридесет', 'четиридесет', 'петдесет',
  'шестдесет', 'седемдесет', 'осемдесет', 'деветдесет'];
const HUNDREDS = ['', 'сто', 'двеста', 'триста', 'четиристотин', 'петстотин',
  'шестстотин', 'седемстотин', 'осемстотин', 'деветстотин'];

/**
 * На български съюзът „и" стои само пред последната съставка на числото:
 * 153 е „сто петдесет и три", но 103 е „сто и три", а 130 — „сто и тридесет".
 * Тоест „и" се слага само когато остатъкът е една дума.
 */
function isSingleWord(n) {
  if (n === 0) return false;
  if (n < 20) return true;
  if (n < 100) return n % 10 === 0;
  return n % 100 === 0;
}

/** Число под 1000 словом. `feminine` сменя „един/два" на „една/две". */
function under1000(n, feminine) {
  if (n === 0) return '';
  const parts = [];
  const h = Math.floor(n / 100);
  const rest = n % 100;

  if (h) parts.push(HUNDREDS[h]);

  if (rest) {
    if (h && isSingleWord(rest)) parts.push('и');
    if (rest < 10) {
      parts.push((feminine ? ONES_F : ONES)[rest]);
    } else if (rest < 20) {
      parts.push(TEENS[rest - 10]);
    } else {
      const t = Math.floor(rest / 10);
      const o = rest % 10;
      if (o) parts.push(`${TENS[t]} и ${(feminine ? ONES_F : ONES)[o]}`);
      else parts.push(TENS[t]);
    }
  }
  return parts.filter(Boolean).join(' ');
}

function integerWords(n) {
  if (n === 0) return 'нула';
  const parts = [];

  const millions = Math.floor(n / 1_000_000);
  const thousands = Math.floor((n % 1_000_000) / 1000);
  const rest = n % 1000;

  if (millions) {
    parts.push(millions === 1 ? 'един милион' : `${under1000(millions, false)} милиона`);
  }
  if (thousands) {
    parts.push(thousands === 1 ? 'хиляда' : `${under1000(thousands, true)} хиляди`);
  }
  if (rest) {
    if (parts.length && isSingleWord(rest)) parts.push('и');
    parts.push(under1000(rest, false));
  }
  return parts.filter(Boolean).join(' ');
}

const UNITS = {
  EUR: { major: 'евро', minor: 'евроцента', minorOne: 'евроцент' },
  BGN: { major: 'лева', minor: 'стотинки', minorOne: 'стотинка' },
  USD: { major: 'долара', minor: 'цента', minorOne: 'цент' },
};

/** Например: 24.50 EUR -> „двадесет и четири евро и петдесет евроцента“ */
export function amountInWords(value, currency = 'EUR') {
  const n = Number(value);
  if (!Number.isFinite(n)) return '';
  const negative = n < 0;
  const cents = Math.round(Math.abs(n) * 100);
  const major = Math.floor(cents / 100);
  const minor = cents % 100;

  const unit = UNITS[currency] ?? UNITS.EUR;
  const parts = [integerWords(major), unit.major];

  if (minor) {
    parts.push('и', integerWords(minor), minor === 1 ? unit.minorOne : unit.minor);
  }

  const text = parts.join(' ');
  const full = negative ? `минус ${text}` : text;
  return full.charAt(0).toUpperCase() + full.slice(1);
}
